import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { isNative } from "@/lib/native/platform";
import { getOAuthRedirect } from "@/lib/native/deepLinks";

export default function ResearchConnectorsCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error");
    if (error) { toast.error(`OAuth error: ${error}`); navigate("/partner/research/connectors"); return; }
    if (!code || !state) { toast.error("Missing code or state"); navigate("/partner/research/connectors"); return; }
    const provider = state.split(":")[0];
    // Must match the redirectUri sent at init. Native uses the cbam:// deep link; web is unchanged.
    const redirectUri = isNative()
      ? getOAuthRedirect("partner/research/connectors/callback")
      : `${window.location.origin}/partner/research/connectors/callback`;
    supabase.functions.invoke(`research-oauth-exchange-${provider}`, { body: { code, redirectUri, state } })
      .then(({ error: e }) => {
        if (e) toast.error(`Exchange failed: ${e.message}`);
        else toast.success(`Connected to ${provider}`);
        navigate("/partner/research/connectors");
      });
  }, [params, navigate]);

  return (
    <div className="py-12 text-center text-sm text-muted-foreground">
      Completing connection…
    </div>
  );
}
